import { Injectable } from '@angular/core';
import { data_city_geo } from '../data/data_city_geo';

export interface City {
    name: string;
    state: string;
    latitude: number;
    longitude: number;
    distance?: number;
}

interface DataCityGeo {
    ibgeId: number;
    nome: string;
    latitude: number;
    longitude: number;
    mesorregiaoNome: string;
    UFSigla: string;
    UFNome: string;
}

@Injectable({
    providedIn: 'root'
})
export class CityService {


    findCitiesInRadius(referenceCity: DataCityGeo, radiusInKm: number): City[] {

        const cities = data_city_geo.map(geo => ({
            name: geo.nome,
            state: geo.UFSigla,
            latitude: geo.latitude,
            longitude: geo.longitude
        }));

        // Filter cities based on the radius and calculate distances
        return cities
            .map(city => ({
                ...city,
                distance: this.calculateDistance({
                    name: referenceCity.nome,
                    state: referenceCity.UFSigla,
                    latitude: referenceCity.latitude,
                    longitude: referenceCity.longitude
                }, city)
            }))
            .filter(city =>
                // Exclude the reference city itself and include only cities within radius
                city.name !== referenceCity.nome &&
                city.distance <= radiusInKm
            )
            .sort((a, b) => a.distance - b.distance);
    }


    // findCitiesInRadiusOptimized(referenceCity: City, radiusInKm: number): Observable<City[]> {
    //     if (!referenceCity || radiusInKm <= 0) {
    //         return of([]);
    //     }

    //     // Get the state of the reference city and possibly adjacent states
    //     return this.http.get<any>(`${this.IBGE_API_BASE_URL}/localidades/estados/${referenceCity.state}/municipios`)
    //         .pipe(
    //             switchMap(adjacentStates => {
    //                 const stateIds = [referenceCity.state, ...adjacentStates.map((state: any) => state.sigla)];

    //                 // Create an array of requests, one for each state
    //                 const requests = stateIds.map(stateId =>
    //                     this.http.get<IBGEMunicipality[]>(`${this.IBGE_API_BASE_URL}/localidades/estados/${stateId}/municipios`)
    //                 );

    //                 // Execute all requests in parallel
    //                 return forkJoin(requests);
    //             }),
    //             map(responses => {
    //                 // Flatten the array of arrays
    //                 const municipalities = responses.flat();

    //                 // Convert IBGE municipalities to our City interface
    //                 const cities = municipalities.map(municipality => ({
    //                     name: municipality.nome,
    //                     state: municipality.microrregiao.mesorregiao.UF.sigla,
    //                     latitude: municipality.centroide ? municipality.centroide.latitude : 0,
    //                     longitude: municipality.centroide ? municipality.centroide.longitude : 0
    //                 }));

    //                 // Filter cities based on the radius and calculate distances
    //                 return cities
    //                     .map(city => ({
    //                         ...city,
    //                         distance: this.calculateDistance(referenceCity, city)
    //                     }))
    //                     .filter(city =>
    //                         city.name !== referenceCity.name &&
    //                         city.distance <= radiusInKm
    //                     )
    //                     .sort((a, b) => a.distance - b.distance);
    //             }),
    //             catchError(error => {
    //                 console.error('Error fetching municipalities from IBGE API', error);
    //                 return of([]);
    //             })
    //         );
    // }

    // Calculate distance between two coordinates using the Haversine formula

    private calculateDistance(city1: City, city2: City): number {
        const R = 6371; // Earth radius in km
        const dLat = this.toRad(city2.latitude - city1.latitude);
        const dLon = this.toRad(city2.longitude - city1.longitude);
        const lat1 = this.toRad(city1.latitude);
        const lat2 = this.toRad(city2.latitude);

        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    private toRad(value: number): number {
        return value * Math.PI / 180;
    }
}
